// src/App.tsx
import { BrowserRouter, Route, Routes, useNavigate, Navigate } from 'react-router-dom';
import { Auth0Provider, useAuth0, withAuthenticationRequired } from '@auth0/auth0-react';
import { LocalAuth0Provider } from './LocalAuthProvider';
import "bootstrap/dist/css/bootstrap.min.css";
import { App as AntApp, ConfigProvider } from 'antd';
import { theme } from './pages/theme';

import Ingresos from './pages/Ingresos';
import Detalle from "./pages/ingresos/Detalle";
import JohnDeere from "./pages/JohnDeere";
import JohnDeereConnectSuccess from './components/john-deere/login/JohnDeereConnectSuccess';
import IngresoCamiones from './pages/reportes/IngresoCamiones';
import { MainLayout } from './components/MainLayout';
import CrearObjetos from './pages/insumos/objetos/CrearObjetos';
import EditarObjetos from './pages/insumos/objetos/EditarObjetos';
import CrearInsumos from './pages/insumos/insumos/CrearInsumos';
import ListarObjetos from './pages/insumos/objetos/ListarObjetos';
import ListarInsumos from './pages/insumos/insumos/ListarInsumos';
import EditarInsumos from './pages/insumos/insumos/EditarInsumos';
import Reportes from './pages/reportes/Reportes';
import CrearIngresos from './pages/insumos/ingresos/CrearIngresos';
import Produccion from './pages/reportes/produccion/Produccion';
import Stock from './pages/reportes/Stock';
import EvolucionStock from './pages/reportes/EvolucionStock';
import Lotes from './pages/reportes/Lotes';
import DetalleProduccion from './pages/reportes/produccion/detalle_produccion/DetalleProduccion';
//import IncidentesDescripcion from './pages/incidentes/descripcion/IncidentesDescripcion';
//import Incidentes from './pages/incidentes/Incidentes';
import CrearSectores from './pages/insumos/sectores/CrearSectores';
import ListarSectores from './pages/insumos/sectores/ListarSectores';
import EditarSectores from './pages/insumos/sectores/EditarSectores';
import CrearEquipos from './pages/insumos/equipos/CrearEquipos';
import ListarEquipos from './pages/insumos/equipos/ListarEquipos';
import EditarEquipos from './pages/insumos/equipos/EditarEquipos';
import CrearMotores from './pages/insumos/motores/CrearMotores';
import ListarMotores from './pages/insumos/motores/ListarMotores';
import EditarMotores from './pages/insumos/motores/EditarMotores';
import CrearDepositos from './pages/insumos/depositos/CrearDepositos';
import CrearOrdenCompra from './pages/insumos/ordencompra/CrearOrdenCompra';
import ListarDepositos from './pages/insumos/depositos/ListarDepositos';
import ListarOrdenCompra from './pages/insumos/ordencompra/ListarOrdenCompra';
import ImprimirOrdenCompra from './pages/insumos/ordencompra/ImprimirOCompra';
//import Ofertas from './pages/ofertas/NuevaOferta';
import Clasificacion from './pages/clasificacion/clasificacion';
import EditarDepositos from './pages/insumos/depositos/EditarDepositos';
import EditarOrdenCompraPage from './pages/insumos/ordencompra/EditarOrdenCompra';
import ListarIngresos from './pages/insumos/ingresos/ListarIngresos';
import EditarIngresos from './pages/insumos/ingresos/EditarIngresos';
import ImprimirIngresos from './pages/insumos/ingresos/ImprimirIngresos';
import CrearEgresos from './pages/insumos/egresos/CrearEgresos';
import ListarEgresos from './pages/insumos/egresos/ListarEgresos';
import ImprimirEgresos from './pages/insumos/egresos/ImprimirEgresos';
import EditarEgresos from './pages/insumos/egresos/EditarEgresos';
import ListarPendienteIngreso from './pages/insumos/informes/ListarPendienteIngreso';
import ListarPendienteFacturar from './pages/insumos/informes/ListarPendienteFacturar';
import ListarPendienteOrdenes from './pages/insumos/informes/ListarPendienteOrdenes';
import DiarioMovimientos from './pages/insumos/informes/DiarioMovimientos';
import Inventario from './pages/insumos/informes/Inventario';
import ConsumoInterno from './pages/insumos/informes/ConsumoInterno';
import Pesaje from './pages/balanza/Pesaje';
import Listar_Pesaje from './pages/balanza/Listar_Pesaje';
import EditarBalanzaPage from './pages/balanza/EditarBalanza';
import SegundaPesada from './pages/balanza/SegundaPesada';
import ImprimirTicketBalanza from './pages/balanza/ImprimirBalanza';
import A_Produccion from './pages/produccion/A_Produccion';
import ProduccionLayout from './components/produccion/ProduccionLayout';
import ProductorEstablecimientoPage from './pages/relacion/ProductorEstablecimientoLote';
import Transporte from './pages/relacion/Transporte';
import ListarTaraFardos from './pages/relacion/ListarTaraFardos';
import ConfigurarPlayaModulosRollos from './pages/datosfijos/PlayaModulosRollos';
import Presentacion from './pages/datosfijos/Presentacion';
import ListarPendienteFletes from './pages/fletes/ListarPendienteFletes';
import ListarLiquidacionesFletes from './pages/fletes/ListarLiquidacionesFletes';
import ImprimirLiquidacionFletes from './pages/fletes/ImprimirLiquidacionFletes';
import ListadoContratos from './components/ordenes/listadocontratos';
//import NuevoContratoModal from './components/logistica/CrearContrato';
//import SinContratos from './pages/logistica/SinContratos';
import ListadoCeldas from './pages/balanza/ListadoCeldas';
import Padron from './pages/padron/ListadoPadron';
import AltaPadron from './pages/padron/AltaPadron';
import EditarPadron from './pages/padron/EditarPadron';
import ListadoClasificacion from './components/clasificacion/ListadoClasificacion';
import AltaClasificacion from './components/clasificacion/FormularioClasificacion';
import EmisionClasificacion from './components/clasificacion/EmisionClasificacion';
import EmisionLotes from './components/clasificacion/EmisionLotes';
import TrabajoClasificacion from './components/clasificacion/TrabajoClasificacion';
import ImportarClasificacion from './components/clasificacion/importarClasificacion';
import ListadoLote from './pages/clasificacion/ListadoLotes';
import CantidadFLotes from './components/datosfijos/CantidadFLotes';
import AltaUsuarios from './components/usuarios/altausuarios';
import AutorizacionUsuarios from './components/usuarios/autorizacionusuarios';
import AltaOrdenes from './components/ordenes/altaordenes';
import AltaContratos from './components/ordenes/altacontratos';
import AltaAplicacionPage from './pages/ordenes/AltaAplicacion';
import EmisionContratos from './components/ordenes/emisioncontratos';
import ListadoOrdenes from './components/ordenes/listadoordenes';
import AltasInContratos from './components/ordenes/altasincontratos';
import EmisionOrdenes from './components/ordenes/emisionordenes';
import RecepcionDespacho from './components/ordenes/recepcion_despacho';
import ListadoRecepcionDespacho from './components/ordenes/ListadoRecepcionDespacho';
import EmisionRecdes from './components/ordenes/emisionrecdes';
import ListadoProduccion from './components/produccion/ListadoProduccion';
import EmisionProduccion from './components/produccion/EmisionProduccion';
import AjustarSemilla from './components/produccion/herramientas/AjustarSemilla';
import EditarProduccion from './components/produccion/EditarProduccion';
import CrearSilobolsaPage from './pages/silobolsa/CrearSilobolsa';
import EditarSilobolsaPage from './pages/silobolsa/EditarSilobolsa';
import ListadoSilobolsa from './components/silobolsa/listado_silobolsa';
import EmisionSilobolsa from './components/silobolsa/emisionsilobolsa';
import ConfiguracionProduccion from './pages/ConfiguracionProduccion';
import EgresoCamiones from './pages/reportes/EgresoCamiones';
import PrettyLoader from './components/PrettyLoader';
import { UpdateBanner } from './components/UpdateBanner';
import { useVersionCheck } from './hooks/useVersionCheck';
import Desmote from './components/produccion/desmote';
import PrevioDesmote from './components/produccion/previoDesmote';
import CalculoSemillas from './components/datosfijos/CalculoSemillas';
import AltaRollos from './components/balanza/altarollos';
import { ProduccionProvider } from './context/ProduccionContext';
import FabricaPage from './pages/Fabrica';
import InsumosPage from './pages/Insumos';
import ListarCompraAlgodon from './components/liquidacion/listar_compraalgodon';
import LiquidacionCompra from './components/liquidacion/liquidacion_compra';
import Retenciones from './components/liquidacion/listar_retenciones';
import AltaRetenciones from './components/liquidacion/alta_retenciones';
import EditarRetenciones from './components/liquidacion/editar_retenciones';
import AsignarComprobante from './components/liquidacion/asignar_comprobante';
import EmisionCompraAlgodon from './components/liquidacion/emision_compraalgodon';
import ListarServiciosDesmote from './components/liquidacion/listar_servicio_desmote';
import LiquidacionServicio from './components/liquidacion/liquidacion_servicio';
import EmisionServicioDesmote from './components/liquidacion/emision_serviciodesmote';
import EditarCompraAlgodon from './components/liquidacion/editar_compraalgodon';
import EditarServicioDesmote from './components/liquidacion/editar_servicio_desmote';
import ImprimirCompraAlgodon from './components/liquidacion/ImprimirCompraAlgodon';
import ImprimirServicioDesmote from './components/liquidacion/ImprimirServicioDesmote';
import InformeCompras from './pages/reportes/Compras/EstadisticasCompras';
import ListadoDisponible from './pages/reportes/Compras/ListadoDisponible';
import DetalleAplicacionCompras from './pages/reportes/Compras/DetalleAplicacionCompras';
import DetalleIngresoCompras from './pages/reportes/Compras/DetalleIngresoCompras';
import DetalleDesmote from './pages/reportes/Compras/DetalleDesmote';
import DetalleDesdeDesmote from './pages/reportes/Compras/DetalleDesdeDesmote';
import DetalleStock from './pages/reportes/Compras/DetalleStock';
import DetalleDisponible from './pages/reportes/Compras/DetalleDisponible';
import DetalleAplicacionVentas from './pages/reportes/Compras/DetalleAplicacionVentas';
import DetalleSalidasVentas from './pages/reportes/Compras/DetalleSalidasVentas';
import DetalleOtrasSalidas from './pages/reportes/Compras/DetalleOtrasSalidas';
import ClasificacionOrdenes from './components/ordenes/clasificacionordenes';
import Loteo from './components/clasificacion/loteo';
import ConfiguracionContable from './components/configuracion/ConfiguracionContable';

// En dev local sin Auth0 configurado, usamos el mock de autenticación
const IS_LOCAL_DEV = !process.env.REACT_APP_AUTH0_DOMAIN;

const ProtectedRoute = ({ component, ...args }: any) => {
  const Component = withAuthenticationRequired(component, args);
  return <Component />;
};

const Auth0ProviderWithRedirectCallback = ({ children, ...props }: any) => {
  const navigate = useNavigate();
  const onRedirectCallback = (appState: any) => {
    navigate((appState && appState.returnTo) || '/reportes/compras');
  };
  return (
    <Auth0Provider onRedirectCallback={onRedirectCallback} {...props}>
      {children}
    </Auth0Provider>
  );
};

// New component to contain the routes
function AppContent() {
  const { user, isLoading } = useAuth0();
  const solo_reportes = user?.solo_reportes;
  const verificado = user?.verificado;
  const tipo_usuario = user?.tipo_usuario;
  const updateAvailable = useVersionCheck();

  // Wait for Auth0 to finish loading and user data to be available
  if (isLoading) {
    return <PrettyLoader />;
  }

  return (
    <MainLayout>
      {updateAvailable && <UpdateBanner />}
      <Routes>
        {verificado === 0 || verificado === undefined ? (
          <>
            <Route path="/" element={<AltaUsuarios />} />
          </>
        ) : solo_reportes === 1 ? (
          <>
            <Route index path="/" element={<Navigate to="/reportes/compras" replace />} />
            <Route path="/reportes" element={<Reportes />} />
            <Route path="/reportes/ingresocamiones" element={<IngresoCamiones />} />
            <Route path="/reportes/egresocamiones" element={<EgresoCamiones />} />
            <Route path="/reportes/produccion" element={<Produccion />} />
            <Route path="/reportes/stock" element={<Stock />} />
            <Route path="/reportes/lotes" element={<Lotes />} />
            <Route path="/reportes/produccion/detalle" element={<DetalleProduccion />} />
            <Route path="/reportes/stock/EvolucionStock" element={<EvolucionStock />} />
            {tipo_usuario === "D" && (
              <Route path="/autorizacionusuarios" element={<AutorizacionUsuarios />} />
            )}
          </>
        ) : tipo_usuario === "O" ? (
          <>
            <Route index path="/" element={<Navigate to="/ListadoProduccion" replace />} />
            <Route path="/ListadoProduccion" element={<ListadoProduccion />} />
            <Route path="/EmisionProduccion" element={<EmisionProduccion />} />
            <Route path="/desmote" element={<Desmote />} />
            <Route path="/previoDesmote" element={<PrevioDesmote />} />
            <Route path="/produccion_fardos" element={<ProduccionLayout />} />
            <Route path="/a_produccion" element={<A_Produccion />} />
          </>
        ) : (
          <>
            <Route index path="/" element={<Navigate to="/reportes/compras" replace />} />
            <Route path="/ingresos" element={<ProtectedRoute component={Ingresos} />} />
            <Route path="/ingresos/:uuid" element={<ProtectedRoute component={Detalle} />} />
            <Route path="/john-deere" element={<JohnDeere />} />
            <Route path="/john-deere/success" element={<JohnDeereConnectSuccess />} />
            <Route path="/reportes" element={<Reportes />} />
            <Route path="/reportes/ingresocamiones" element={<IngresoCamiones />} />
            <Route path="/reportes/egresocamiones" element={<EgresoCamiones />} />
            <Route path="/reportes/produccion" element={<Produccion />} />
            <Route path="/reportes/stock" element={<Stock />} />
            <Route path="/reportes/lotes" element={<Lotes />} />
            <Route path="/reportes/produccion/detalle" element={<DetalleProduccion />} />
            <Route path="/reportes/stock/EvolucionStock" element={<EvolucionStock />} />
            <Route path="/crear_objetos" element={<CrearObjetos />} />
            <Route path="/listar_objetos" element={<ListarObjetos />} />
            <Route path="/editar_objetos/:id" element={<EditarObjetos />} />
            <Route path="/crear_insumos" element={<CrearInsumos />} />
            <Route path="/listar_insumos/" element={<ListarInsumos />} />
            <Route path="/editar_insumos/:id" element={<EditarInsumos />} />
            <Route path="/fabrica" element={<FabricaPage />} />
            <Route path="/insumos" element={<InsumosPage />} />
            <Route path="/crear_sectores" element={<CrearSectores />} />
            <Route path="/listar_sectores" element={<ListarSectores />} />
            <Route path="/editar_sectores/:id" element={<EditarSectores />} />
            <Route path="/crear_equipos" element={<CrearEquipos />} />
            <Route path="/listar_equipos" element={<ListarEquipos />} />
            <Route path="/editar_equipos/:id" element={<EditarEquipos />} />
            <Route path="/crear_motores" element={<CrearMotores />} />
            <Route path="/listar_motores/" element={<ListarMotores />} />
            <Route path="/editar_motores/:id" element={<EditarMotores />} />
            <Route path="/crear_depositos" element={<CrearDepositos />} />
            <Route path="/listar_depositos/" element={<ListarDepositos />} />
            <Route path="/crear_ordencompra" element={<CrearOrdenCompra />} />
            <Route path="/listar_ocompra" element={<ListarOrdenCompra />} />
            <Route path="/imprimir_ocompra/:id" element={<ImprimirOrdenCompra />} />
            <Route path="/clasificacion" element={<Clasificacion />} />
            <Route path="/editar_depositos/:id" element={<EditarDepositos />} />
            <Route path="/editar_ocompra/:id" element={<EditarOrdenCompraPage />} />
            <Route path="/crear_ingresos" element={<CrearIngresos />} />
            <Route path="/listar_ingresos" element={<ListarIngresos />} />
            <Route path="/editar_ingresos/:id" element={<EditarIngresos />} />
            <Route path="/imprimir_ingresos/:id" element={<ImprimirIngresos />} />
            <Route path="/crear_egresos" element={<CrearEgresos />} />
            <Route path="/listar_egresos/" element={<ListarEgresos />} />
            <Route path="/imprimir_egresos/:id" element={<ImprimirEgresos />} />
            <Route path="/editar_egresos/:id" element={<EditarEgresos />} />
            <Route path="/listar_pendiente_ingreso" element={<ListarPendienteIngreso />} />
            <Route path="/listar_pendiente_facturar" element={<ListarPendienteFacturar />} />
            <Route path="/listar_pendiente_ordenes" element={<ListarPendienteOrdenes />} />
            <Route path="/diario_movimientos" element={<DiarioMovimientos />} />
            <Route path="/inventario" element={<Inventario />} />
            <Route path="/consumo_interno" element={<ConsumoInterno />} />
            <Route path="/pesaje" element={<Pesaje />} />
            <Route path="/listar_pesaje" element={<Listar_Pesaje />} />
            <Route path="/balanza/editar/:id_empresa/:id_sucursal/:registroId" element={<EditarBalanzaPage />} />
            <Route path="/segunda_pesada/:registroId" element={<SegundaPesada />} />
            <Route path="/imprimir_balanza/:id" element={<ImprimirTicketBalanza />} />
            <Route path="/a_produccion" element={<A_Produccion />} />
            <Route path="/produccion_fardos" element={<ProduccionLayout />} />
            <Route path="/listar_productor_establecimiento_lote" element={<ProductorEstablecimientoPage />} />
            <Route path="/transporte" element={<Transporte />} />
            {/* Rutas antiguas mantenidas por compatibilidad */}
            <Route path="/listar_choferes" element={<Transporte />} />
            <Route path="/listar_camiones" element={<Transporte />} />
            <Route path="/configuracion_produccion" element={<ConfiguracionProduccion />} />
            {/* Rutas antiguas mantenidas por compatibilidad */}
            <Route path="/listar_tara_fardos" element={<ListarTaraFardos />} />
            <Route path="/playa_modulos_rollos" element={<ConfigurarPlayaModulosRollos />} />
            <Route path="/presentacion" element={<Presentacion />} />
            <Route path="/listar_pendientes_fletes" element={<ListarPendienteFletes />} />
            <Route path="/listar_liquidaciones_fletes" element={<ListarLiquidacionesFletes />} />
            <Route path="/imprimir_liquidacion_fletes/:id" element={<ImprimirLiquidacionFletes />} />
            <Route path="/contratos" element={<ListadoContratos />} />
            <Route path="/listado_celdas" element={<ListadoCeldas />} />
            <Route path="/listado_padron" element={<Padron />} />
            <Route path="/alta_padron" element={<AltaPadron />} />
            <Route path="/editar_padron/:id" element={<EditarPadron />} />
            <Route path="/listado_clasificacion" element={<ListadoClasificacion />} />
            <Route path="/FormularioClasificacion" element={<AltaClasificacion />} />
            <Route path="/EmisionClasificacion/:id" element={<EmisionClasificacion />} />
            <Route path="/emision_lotes" element={<EmisionLotes />} />
            <Route path="/TrabajoClasificacion/:id" element={<TrabajoClasificacion />} />
            <Route path="/ImportarClasificacion" element={<ImportarClasificacion />} />
            <Route path="/listado_lote/:nroLote" element={<ListadoLote />} />
            {/* Ruta antigua mantenida por compatibilidad */}
            <Route path="/cantidadFlotes" element={<CantidadFLotes />} />
            <Route path="/autorizacionusuarios" element={<AutorizacionUsuarios />} />
            <Route path="/altaordenes" element={<AltaOrdenes />} />
            <Route path="/altacontratos" element={<AltaContratos />} />
            <Route path="/listadocontratos" element={<ListadoContratos />} />
            <Route path="/altaaplicacion" element={<AltaAplicacionPage />} />
            <Route path="/emisioncontratos" element={<EmisionContratos />} />
            <Route path="/listadoordenes" element={<ListadoOrdenes />} />
            <Route path="/altasincontratos" element={<AltasInContratos />} />
            <Route path="/emisionordenes" element={<EmisionOrdenes />} />
            <Route path="/recepcion_despacho" element={<RecepcionDespacho />} />
            <Route path="/listado_recepcion_despacho" element={<ListadoRecepcionDespacho />} />
            <Route path="/emisionrecdes/:id" element={<EmisionRecdes />} />
            <Route path="/ListadoProduccion" element={<ListadoProduccion />} />
            <Route path="/EmisionProduccion" element={<EmisionProduccion />} />
            <Route path="/crear_silobolsa" element={<CrearSilobolsaPage />} />
            <Route path="/editar_silobolsa/:id" element={<EditarSilobolsaPage />} />
            <Route path="/emision_silobolsa/:id" element={<EmisionSilobolsa />} />
            {/* Ruta antigua mantenida por compatibilidad */}
            <Route path="/listado_silobolsa" element={<ListadoSilobolsa />} />
            <Route path="/desmote" element={<Desmote />} />
            <Route path="/previoDesmote" element={<PrevioDesmote />} />
            <Route path="/calculo_semillas" element={<CalculoSemillas />} />
            {tipo_usuario === "D" && (
              <>
                <Route path="/herramientas/ajustar-semilla" element={<AjustarSemilla />} />
                <Route path="/produccion/editar/:id_empresa/:id_sucursal/:id_produccion" element={<EditarProduccion />} />
              </>
            )}
            <Route path="/altarollos/:registroId" element={<AltaRollos />} />
            <Route path="/listar_compraalgodon" element={<ListarCompraAlgodon />} />
            <Route path="/liquidacion/compra" element={<LiquidacionCompra />} />
            <Route path="/liquidacion/nueva_compraalgodon" element={<LiquidacionCompra />} />
            <Route path="/liquidacion/retenciones" element={<Retenciones />} />
            <Route path="/liquidacion/alta_retenciones" element={<AltaRetenciones />} />
            <Route path="/liquidacion/editar_retenciones/:id" element={<EditarRetenciones />} />
            <Route path="/liquidacion/asignar_comprobante/:id_liquidacion" element={<AsignarComprobante />} />
            <Route path="/liquidacion/asignar_comprobante_servicio/:id_liquidacion" element={<AsignarComprobante />} />
            <Route path="/listar_compras_algodon" element={<ListarCompraAlgodon />} />
            <Route path="/liquidacion/emision_compraalgodon/:id" element={<EmisionCompraAlgodon />} />
            <Route path="/listar_servicio_desmote" element={<ListarServiciosDesmote />} />
            <Route path="/liquidacion_servicio" element={<LiquidacionServicio />} />
            <Route path="/emision_serviciodesmote/:id" element={<EmisionServicioDesmote />} />
            <Route path="/editar_compraalgodon/:id" element={<EditarCompraAlgodon />} />
            <Route path="/editar_servicio_desmote/:id" element={<EditarServicioDesmote />} />
            <Route path="/imprimir_compraalgodon/:id" element={<ImprimirCompraAlgodon />} />
            <Route path="/imprimir_servicio_desmote/:id" element={<ImprimirServicioDesmote />} />
            <Route path="/reportes/compras" element={<InformeCompras />} />
            <Route path="/reportes/compras/detalle/aplicacion-compras" element={<DetalleAplicacionCompras />} />
            <Route path="/reportes/compras/detalle/ingreso-compras" element={<DetalleIngresoCompras />} />
            <Route path="/reportes/compras/detalle/desmote" element={<DetalleDesmote />} />
            <Route path="/reportes/compras/detalle/desde-desmote" element={<DetalleDesdeDesmote />} />
            <Route path="/reportes/compras/detalle/ingreso-total" element={<DetalleIngresoCompras />} />
            <Route path="/reportes/compras/detalle/a-ingresar" element={<DetalleAplicacionCompras />} />
            <Route path="/reportes/compras/detalle/aplicacion-ventas" element={<DetalleAplicacionVentas />} />
            <Route path="/reportes/compras/detalle/salidas-ventas" element={<DetalleSalidasVentas />} />
            <Route path="/reportes/compras/detalle/otras-salidas" element={<DetalleOtrasSalidas />} />
            <Route path="/reportes/compras/detalle/total-salidas" element={<DetalleSalidasVentas />} />
            <Route path="/reportes/compras/detalle/a-salir" element={<DetalleAplicacionVentas />} />
            <Route path="/reportes/compras/detalle/stock" element={<DetalleStock />} />
            <Route path="/reportes/compras/detalle/disponible-stock" element={<DetalleStock />} />
            <Route path="/reportes/compras/detalle/disponible" element={<DetalleDisponible />} />
            <Route path="/clasificacionordenes" element={<ClasificacionOrdenes />} />
            <Route path="/loteo" element={<Loteo />} />
            <Route path="/clasificacion/loteo/" element={<Loteo />} />
            <Route path="/listadodisponible" element={<ListadoDisponible />} />
            <Route path="/configuracion/contable" element={<ConfiguracionContable />} />
          </>
        )}
      </Routes>
    </MainLayout>
  );
}

function App() {
  return (
    <AntApp>
      <BrowserRouter>
        <ConfigProvider theme={theme}>
          {IS_LOCAL_DEV ? (
            // Dev local sin Auth0: usar mock de autenticación
            <LocalAuth0Provider>
              <ProduccionProvider>
                <AppContent />
              </ProduccionProvider>
            </LocalAuth0Provider>
          ) : (
            // Producción: Auth0 real
            <Auth0ProviderWithRedirectCallback
              domain={process.env.REACT_APP_AUTH0_DOMAIN}
              clientId={process.env.REACT_APP_AUTH0_CLIENT_ID}
              cacheLocation="localstorage"
              useRefreshTokens={true}
              authorizationParams={{
                redirect_uri: window.location.origin,
                audience: "servisoft-backend-api",
                scope: "read:rollos update:rollos create:users read:users delete:users openid profile email offline_access",
              }}
            >
              <ProduccionProvider>
                <AppContent />
              </ProduccionProvider>
            </Auth0ProviderWithRedirectCallback>
          )}
        </ConfigProvider>
      </BrowserRouter>
    </AntApp>
  );
}

export default App;
